import objectPath from 'object-path'
import { fetchQueue } from './api'

export const reducer = (state, paths) =>
  (paths.length === 0 ?
    state :
    paths.reduce((substate, path) => {
      objectPath.set(substate, path, objectPath.get(state, path));
      return substate;
    }, {}))

export function canWriteStorage(data = 'default') {
  var localStorage = null;

  try {
    localStorage = window.localStorage;
    if (!localStorage) return false;

    localStorage.setItem('storageChecker', data)
    if (!localStorage.getItem('storageChecker')) return false;

    localStorage.removeItem('storageChecker')
    return true;
  } catch (e) {
    return false;
  }
}

export function canWriteSessionStorage(data = 'default') {
  var sessionStorage = null;

  try {
    sessionStorage = window.sessionStorage;
    if (!sessionStorage) return false;

    sessionStorage.setItem('storageChecker', data)
    if (!sessionStorage.getItem('storageChecker')) return false;

    sessionStorage.removeItem('storageChecker')
    return true;
  } catch (e) {
    return false;
  }
}

export function hexToRGB(hex, alpha) {

  let r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16)

  if (alpha)
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")"
  else
    return "rgb(" + r + ", " + g + ", " + b + ")"

}

export function uidToColor(str) {

  let hash = 0;

  for (let i = 0; i < str.length; i++)
      hash = str.charCodeAt(i) + ((hash << 7) - hash);

  let color = '#';

  for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
  }

  return color;

}

function uriToJSON() {
  const loc = location.href.replace('#state', '&state') // ensure state is included in parsing
  let r = /[?&]([^=#]+)=([^&#]*)/g, j = {}, m
  if ( location.href.indexOf('@@CDN') > 0 )
    while (m = r.exec(loc)) {
      j[m[1]] = m[2]
    }
  return j
}

function validateKeys(p) {
  let result = false
  let f = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  if ( typeof p == 'object'
    && p.orgId
    && p.widgetId
    && p.orgId.match(f)
    && p.widgetId.match(f)
  )
  result = true
  return result
}

function fetchFromQueue() {
  const f = fetchQueue('create')
  const queue = (f && f.length == 2) ? { orgId: f[0], widgetId: f[1] } : null
  if (queue && queue.orgId && queue.widgetId && validateKeys(queue))
    return queue

  return null
}

function fetchFromURL() {
  let p = uriToJSON()
  
  if (p.state) {
    const rootState = JSON.parse(decodeURIComponent(p.state));
    if (rootState && rootState.state) {
      const innerState = JSON.parse(rootState.state);
      p = {
        ...p,
        ...innerState
      }
    }
  }

  if (p.orgId && p.widgetId && validateKeys(p))
    return {
      orgId : p.orgId,
      widgetId: p.widgetId,
      mode: p.mode
    }

  return null
}

function fetchFromScript() {
  const script = document.querySelector('script#swaychat')
  if (script && script.dataset && validateKeys(script.dataset))
    return script.dataset

  return null
}

export const w = {
  init() {

    let f = fetchFromQueue() || fetchFromURL() || fetchFromScript()

    if (f) {
      this.dataset = f
      this.orgId = f.orgId
      this.widgetId = f.widgetId
      this.key = this.orgId + '|' + this.widgetId
      this.mode = f.mode && ['chat','popout','frameStorage','social'].indexOf(f.mode) > -1 ? f.mode : 'chat'
    }

  },
  app(mode) {
    let url = '//@@CDN/assets/html/app.html?mode='+mode
    url += this.orgId ? '&orgId=' + this.orgId : ''
    url += this.widgetId ? '&widgetId=' + this.widgetId : ''
    return url
  }
}

w.init()
